/**
 * Created by hao.cheng on 2017/4/16.
 */
import React from 'react';
import { Form, Input, Button, Checkbox,Layout } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {Redirect} from 'react-router-dom'
import { fetchData, receiveData } from '@/reducers/httpReducer';
import {actions as userActions, reducer as user} from '../../reducers/userReducer'
import { showMessage } from '../util/NoticeMessage'
import { PLATFORM_OEM_URL } from '@/fetch/url'

import { get } from '@/fetch/fetch'
import { GET_BG } from '@/fetch/url'

import ichongpng from '../pic/systitle-ichong.png'
import xjwlpng from '../pic/systitle-xingjiongwulian.png'
import beforebg from '../pic/bgbefore.png'
import backbg from '../pic/bgafter.png'
import vcode from "../pic/vcode.png"
import userpng from "../pic/user.png"
import lockpng from "../pic/lock.png"

import styles from './Login.less';

const { Footer } = Layout;

const {user_login} = userActions

const FormItem = Form.Item;

class Login extends React.Component {
    constructor( props ) {
        super(props)
        this.state = {img:'', vcodeimg:'',titlepng:'',foottitle:''}
        this.getBg = this.getBg.bind(this)
    }
    componentWillMount() {
        /*const { receiveData } = this.props;
        receiveData(null, 'auth');*/
        this.setState({
            vcodeimg:"/rand?t=" + new Date().getTime()
        },this.getPlatformOem)
        //this.getBg()
    }

    getPlatformOem = () => {
        let that = this;

        get(PLATFORM_OEM_URL).then(function (result) {
            if(result.success) {
                let pngurl = '';
                if (result.content.name == 'ichong') {
                    pngurl = ichongpng
                } else if (result.content.name == 'xingjiongwulian') {
                    pngurl = xjwlpng
                }

                that.setState({
                    titlepng:pngurl,
                    foottitle:result.content.title,
                })
            } else {
                that.setState({
                    titlepng:'',
                    foottitle:'',
                })
            }
        }).catch(function(error){
            that.setState({
                titlepng:'',
                foottitle:'',
            })
            console.log(error);
        });
    }


    componentWillReceiveProps(nextProps) {
        const { auth: nextAuth = {} } = nextProps;
        const { history } = this.props;

        let errmsg = nextProps.msg
        if (errmsg.type === 2) {
            showMessage("error", errmsg.content,"");
            nextProps.msg.type = 1;
            this.updateVcodeImg();
            return ;
        }

        if (nextAuth.data && nextAuth.data.uid) {// 判断是否登陆
            localStorage.setItem('user', JSON.stringify(nextAuth.data));
            history.push('/');
        }
    }
    handleSubmit = (e) => {
        e.preventDefault();
        let that = this
        this.props.form.validateFields((err, values) => {
            if (!err) {
                console.log('Received values of form: ', values);
                that.props.user_login({
                    username:values.username,
                    password:values.password,
                    vcode:values.vcode,
                })
                /*const { fetchData } = this.props;
                if (values.userName === 'admin' && values.password === 'admin') fetchData({funcName: 'admin', stateName: 'auth'});
                if (values.userName === 'guest' && values.password === 'guest') fetchData({funcName: 'guest', stateName: 'auth'});*/
            }
        });
    };

    updateVcodeImg = () => {
        this.setState({
            vcodeimg:"/rand?t=" + new Date().getTime()
        })
    };

    getBg = () => {
        let that = this
        get(GET_BG).then(function (result) {
            if(result.success) {
                that.setState({
                    bg:result.img
                })
            }
        });
    };
    gitHub = () => {
        window.location.href = 'https://github.com/login/oauth/authorize?client_id=792cdcd244e98dcd2dee&redirect_uri=http://localhost:3006/&scope=user&state=reactAdmin';
    };
    render() {
        if(this.props.user && this.props.user.isLogin) {
            console.log('login success go to mainFrame')
            return <Redirect to={{pathname: '/'}} />
        }
        const { getFieldDecorator } = this.props.form;
        return (
            <Layout>
            <div className="login" style={{background:'url('+beforebg+') no-repeat',backgroundSize:'100% 78%'}}>
                <div className="login-form" style={{width: '350px',height:'380px'}}>
                    <div className="login-logo">
                        <img src={this.state.titlepng} alt="" style={{width: '260px'}} />
                    </div>
                    <Form onSubmit={this.handleSubmit} style={{maxWidth: '300px'}}>
                        <FormItem>
                            {getFieldDecorator('username', {
                                rules: [{ required: true, message: '请输入用户名!' }],
                            })(
                                <Input prefix={<img src={userpng} alt="" style={{ fontSize: 13,width: '12px' }} />} placeholder="请输入用户名" />
                            )}
                        </FormItem>
                        <FormItem>
                            {getFieldDecorator('password', {
                                rules: [{ required: true, message: '请输入密码!' }],
                            })(
                                <Input prefix={<img src={lockpng} alt="" style={{ fontSize: 13,width: '12px' }} />} type="password" placeholder="请输入密码" />
                            )}
                        </FormItem>

                        <FormItem style={{width: '140px'}}>
                            {getFieldDecorator('vcode', {
                                rules: [{ required: true, message: '请输入验证码!' }],
                            })(
                                //<Input prefix={<Icon type="lock" style={{ fontSize: 13 }} />} placeholder="验证码" />
                                <Input prefix={<img src={vcode} alt="" style={{ fontSize: 13,width: '12px' }} />} placeholder="验证码" />
                            )}
                        </FormItem>
                        <img onClick={this.updateVcodeImg} src={this.state.vcodeimg} alt="" style={{ width: '112px', float: "right",marginTop: "-61px",marginRight:"5px"}} />
                        <FormItem>
                            {getFieldDecorator('remember', {
                                valuePropName: 'checked',
                                initialValue: true,
                            })(
                                <Checkbox>记住我</Checkbox>
                            )}
                            <a className="login-form-forgot" href="" style={{float: 'right'}}>忘记密码</a>
                            <Button type="primary" htmlType="submit" className="login-form-button" style={{width: '100%'}}>
                                登录
                            </Button>

                        </FormItem>
                    </Form>
                </div>
            </div>
                <Footer style={{ textAlign: 'center' }}>
                    充电桩管理平台 ©2018 Created by {this.state.foottitle}
                    <a href="https://beian.miit.gov.cn/" target="_blank">闽ICP备18023767号-1</a>
                </Footer>
            </Layout>

        );
    }
}

const mapStateToPorps = state => {
    const user = state.user;
    const { auth } = state.http;
    const msg = state.globalState.msg;
    return { auth,user,msg };
};
const mapDispatchToProps = dispatch => ({
    fetchData: bindActionCreators(fetchData, dispatch),
    receiveData: bindActionCreators(receiveData, dispatch),
    user_login:bindActionCreators(user_login,dispatch)
});


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(Login));


// WEBPACK FOOTER //
// ./src/components/pages/Login.jsx